import { isStorageAvailable, StorageWrapper } from "utils/infrastructure/storage-util"

export class BannerStorage {
    storage: StorageWrapper | undefined
    private static instance: BannerStorage
    static KEY = "alter_manual_search"

    private constructor() {
        this.storage = isStorageAvailable ? new StorageWrapper(window.sessionStorage) : undefined
    }

    public static getInstance(): BannerStorage {
        if (!BannerStorage.instance) {
            BannerStorage.instance = new BannerStorage()
        }

        return BannerStorage.instance
    }

    get showBanner() {
        return this.storage?.getString(BannerStorage.KEY) === "true"
    }

    setShowBanner() {
        this.storage?.storeString(BannerStorage.KEY, "true")
    }

    cleanStorage() {
        this.storage?.remove(BannerStorage.KEY)
    }
}
